// =============================================================================
// app/src/componentes/SemDado.tsx — o "[sem dado]" do Grafite (29/10/2026).
//
// Número que não existe NÃO é zero. O mês sem linha no resultado, a margem sem
// custo da mercadoria, o ROIC sem capital digitado: escrever R$ 0,00 ou 0% ali
// é afirmar um fato que ninguém mediu — e o dono decide em cima do que lê.
// O desenho aprovado escreve "[sem dado]", em cinza e na letra do texto (não
// na mono do número), para não passar por um valor.
// =============================================================================

export const SEM_DADO = '[sem dado]';

export default function SemDado({ className = '' }: { className?: string }) {
  return <span className={`font-sans font-normal text-dim ${className}`} data-sem-dado="">{SEM_DADO}</span>;
}
